/* global bocAmchart4, am4core, am4charts, bocVars, chartLanguage */

/**
 * Applies print changes
 *
 * @return {void}
 */
bocAmchart4.modifyForPrint = function () {
    for (var index = 0; index < am4core.registry.baseSprites.length; index++) {
        var chart = am4core.registry.baseSprites[index];
        if (chart.className !== "Container") {
            bocAmchart4.modifyChartForPrint(chart);
            chart.deepInvalidate();
        }
    }
};

bocAmchart4.resetToDefault = function () {
    for (var index = 0; index < am4core.registry.baseSprites.length; index++) {
        var chart = am4core.registry.baseSprites[index];
        if (chart.className !== "Container") {
            bocAmchart4.modifyChartToDefault(chart);
        }
    }
};

/**
 * Property to store the scaling for print
 * @type {number}
 */
bocAmchart4.printScale = 0.9;

/**
 * Function to modify the specific chart for print
 * @param {am4core.XYChart} chart The chart object
 * @return {void}
 */
bocAmchart4.modifyChartForPrint = function (chart) {
    bocAmchart4.initChartVars(chart);
    var scale = 1 / bocAmchart4.printScale;
    // Setting default target width to 13cm (for capture)
    var printWidth = 13;
    //set the default print height to 300, as legend is separate now
    var printHeight = 300 * scale;
    var previousHeight = 400;

    //Class name for print margins
    var printMarginClass = 'amchart-print-margin';

    //If the print height is defined in the shortcode, update the print height
    var args = chart.bocSettings.args;
    if (args !== undefined && args.hasOwnProperty("printheight")) {
        printHeight = parseInt(args.printheight) * scale;
    }
    if (args !== undefined && args.hasOwnProperty("height")) {
        previousHeight = args.height;
    }

    // Resizes all the charts on the page to the specified width and height
    if (chart.legend) {
        var legend = chart.legend.htmlContainer;
        legend.classList.add(printMarginClass);
        legend.classList.remove('hidden-print');
        legend.style.width = (printWidth * scale) + "cm";
    }

    if (chart.title) {
        var title = chart.title.htmlContainer;
        title.classList.add(printMarginClass);
        title.classList.remove('hidden-print');
        title.style.width = (printWidth * scale) + "cm";
    }

    if (chart.notes) {
        var notes = chart.notes.htmlContainer;
        notes.classList.add(printMarginClass);
        notes.classList.remove('hidden-print');
        notes.style.width = (printWidth * scale) + "cm";
    }
    var chartStyle = chart.htmlContainer.style;
    var chartClass = chart.htmlContainer.classList;

    if (chart.bocSettings.type !== 'map') {

        chartClass.add(printMarginClass);

        // Adjusted printWidth to zoom out on pie charts, keeping legend, title, and notes width unchanged.
        if (chart.bocSettings.hasOwnProperty('type')) {
            if (chart.bocSettings.type === 'pie') {
                printWidth = 18;
            }
        }

        chartStyle.maxWidth = (printWidth * scale) + "cm";
        chartStyle.minWidth = (printWidth * scale) + "cm";
        // Only if the chart has a printheight value, and the minheight is greater than the printheight, we want to shrink the chart's print display to the printheight
        if (args.hasOwnProperty("printheight")) {
            // Change the minHeight property to the printheight to allow shrinking of the chart
            chartStyle.minHeight = printHeight + 'px';
        }
        chartStyle.height = printHeight + 'px';
    }

    chart.events.once('validated', function (event) {
        //Isolate only the charts that change height for printing and check to see if chart has a yAxis
        if (event.target.bocSettings.args.hasOwnProperty("printheight") && event.target.yAxes) {
            var yAxisLeft = event.target.yAxes.getIndex(0);
            var yAxisRight = event.target.yAxes.getIndex(1);
            //Isolate charts that have a title on the left vertical axis
            if (yAxisLeft?.title?.currentText) {
                //Invalidate the left Y axis title, so it gets repositioned to the middle of the axis
                yAxisLeft.deepInvalidate();
            }
            //Isolate charts that have a title on the right vertical axis
            if (yAxisRight?.title?.currentText) {
                //Invalidate the right Y axis title, so it gets repositioned to the middle of the axis
                yAxisRight.deepInvalidate();
            }
        }
    });
    bocAmchart4.vars[chart.bocSettings.id].initialHeight = previousHeight;
};

/**
 * Function to modify the specific chart for screen
 * @param {am4core.XYChart} chart The chart object
 * @return {void}
 */
bocAmchart4.modifyChartToDefault = function (chart) {

    // Re-setting the base font property after print
    document.getElementById(chart.bocSettings.id).style.removeProperty('font-size');
    document.getElementById(chart.bocSettings.id + "-titles").style.removeProperty('font-size');
    document.getElementById(chart.bocSettings.id + "-legend").style.removeProperty('font-size');
    document.getElementById(chart.bocSettings.id + "-notes").style.removeProperty('font-size');

    if (bocAmchart4.theme === "bocDark") {
        bocAmchart4.convertToDark(chart);
    }

    var printMarginClass = 'amchart-print-margin';
    chart.series.each(function (series) {
        if (series.originallyHidden) {
            series.hide();
        }
    });

    if (chart.legend) {
        var legend = chart.legend.htmlContainer;
        legend.classList.remove(printMarginClass);
        legend.classList.add('hidden-print');
        legend.style.width = "";

        // If showValueLegendPeriodValueText is true, always display the value text. Otherwise,
        // only display the value text on print.
        if (chart.bocSettings.args.hasOwnProperty("showperiodvalueonscreen")
            && chart.bocSettings.args.showperiodvalueonscreen === "true") {
            chart.legend.valueLabels.template.disabled = false;
        } else {
            chart.legend.valueLabels.template.disabled = true;

            chart.legend.dataItems.each(function (di) {
                if (di.valueLabel) {
                    di.valueLabel.dispose();
                }
            });
        }
    }


    if (chart.title) {
        var title = chart.title.htmlContainer;
        title.classList.remove(printMarginClass);
        title.classList.add('hidden-print');
        title.style.width = "";
    }

    if (chart.notes) {
        var notes = chart.notes.htmlContainer;
        var autoHideNotes = chart.bocSettings.args.hasOwnProperty("autohidenotes") && chart.bocSettings.args.autohidenotes === "true";

        if (autoHideNotes) {
            var showNotesButton = document.createElement("button");
            showNotesButton.className = "bocss-button bocss-button--primary bocss-button--small hidden-print";
            showNotesButton.id = chart.bocSettings.id + "-hide-notes";
            showNotesButton.style.marginBottom = "10px";
            //Adding the button to the bottom of the notesContainer
            notes.parentNode.insertBefore(showNotesButton, notes.nextSibling);
            var buttonText = function (language, isHidden) {

                if (isHidden) {
                    if (language === "en") {
                        return "Show notes";
                    } else {
                        return "Afficher les notes";
                    }
                } else {
                    if (language === "en") {
                        return "Hide notes";
                    } else {
                        return "Cacher les notes";
                    }
                }
            };

            bocAmchart4.initChartVars(chart);
            bocAmchart4.vars[chart.bocSettings.id].notesHeight = notes.style.height;

            //Adding click functionality to the button and toggle the max-height property to show/hide the notes
            var toggleNotes = function () {
                notes.classList.toggle('hidden-notes');
                var isHidden = notes.classList.contains('hidden-notes');
                if (isHidden) {
                    notes.style.transition = "max-height 0.7s cubic-bezier(0.2, 0, 0.2, 1)";
                    notes.style.maxHeight = "0";
                } else {
                    notes.style.transition = "max-height 1.2s cubic-bezier(0.2, 0, 0.2, 1)";
                    notes.style.maxHeight = bocAmchart4.vars[chart.bocSettings.id].notesHeight;
                }
                showNotesButton.textContent = buttonText(chartLanguage, isHidden);
            };

            toggleNotes();
            showNotesButton.addEventListener("click", toggleNotes);
        }

        notes.classList.remove(printMarginClass);
        notes.classList.add('hidden-print');
        notes.style.width = "";
        if (chart.bocSettings.args.hasOwnProperty("lastobservation")
            && (!chart.bocSettings.args.hasOwnProperty("lastobservationonscreen")
                || chart.bocSettings.args.lastobservationonscreen !== "true")
        ) {
            if (chart.bocSettings.args.hasOwnProperty("note")) {
                chart.notes.children.getIndex(1).dispose();
            } else {
                chart.notes.children.getIndex(0).dispose();
            }
        }
    }

    var chartStyle = chart.htmlContainer.style;
    var chartClass = chart.htmlContainer.classList;

    if (chart.bocSettings.args.hasOwnProperty("categoryscrollbar")) {
        if (chart.bocSettings.args.categoryscrollbar === "true") {
            chart.scrollbarX = new am4core.Scrollbar();
            chart.scrollbarX.parent = chart.bottomAxesContainer;
        } else if (!isNaN(chart.bocSettings.args.categoryscrollbar)) {
            chart.scrollbarX = new am4charts.XYChartScrollbar();
            chart.scrollbarX.parent = chart.bottomAxesContainer;
            bocAmchart4.initChartVars(chart);
            if (bocAmchart4.vars[chart.bocSettings.id].hasOwnProperty('scrollBarSeries')) {
                chart.scrollbarX.series.push(bocAmchart4.vars[chart.bocSettings.id]['scrollBarSeries']);
            }
        }
    }

    chartClass.remove(printMarginClass);
    if (chart.bocSettings.type !== 'map') {
        chartStyle.maxWidth = "";
        chartStyle.minWidth = "";
        chartStyle.height = bocAmchart4.vars[chart.bocSettings.id].initialHeight + 'px';
        // Reset the charts minheight back to what it was originally
        if (chart.bocSettings.args.hasOwnProperty("printheight")) {
            chartStyle.minHeight = chartStyle.height;
        }
    }
    bocAmchart4.handlePreZoom(chart);
};

/**
 * Function to generate the SVG from the chart and add it to the print div
 * or use a fallback image from media library
 * @param {am4core.XYChart} chart The chart object
 * @return {void}
 */
bocAmchart4.generatePrintCopy = function (chart) {

    chart.events.once("validated", function () {
        const yAxis = chart.yAxes && chart.yAxes.getIndex(0);
        const xAxis = chart.xAxes && chart.xAxes.getIndex(0);

        if (yAxis instanceof am4charts.CategoryAxis
            && xAxis && xAxis.title && xAxis.title.currentText) {
            xAxis.deepInvalidate();
        }

        chart.series.each(function (series) {
            if (series.isHidden && !series.hiddenInLegend) {
                series.show();
                series.originallyHidden = true;
            }
        });
        chart.invalidate();

        chart.events.once("validated", function (event) {
            // Make the SVG snapshot and add it to the div
            var chartObj = event.target;

            // Fix title container height to avoid title being cut-out during in print
            if (chartObj.title) {
                chartObj.title.htmlContainer.style.height = chartObj.title.contentHeight + "px";
            }
            var waitingForCompletion = setInterval(function () {
                if (am4core.registry.invalidPositions[chartObj.baseId].length === 0
                    && am4core.registry.invalidSprites[chartObj.baseId].length === 0) {
                    clearInterval(waitingForCompletion);
                    var printDiv = document.getElementById(chart.bocSettings.id + 'p');
                    if (chart.bocSettings.args.hasOwnProperty('printoverride')) {
                        var homeUrl = "";
                        if (window.hasOwnProperty("bocVars")) {
                            homeUrl = bocVars.homeUrl;
                        } else {
                            homeUrl = window.CFCT.url;
                        }
                        var image = document.createElement("img");
                        image.src = homeUrl + chart.bocSettings.args.printoverride;
                        printDiv.appendChild(image);
                        bocAmchart4.modifyChartToDefault(chartObj);
                    } else {
                        //try modifying the css here to make all white text black... etc
                        chartObj.exporting.useWebFonts = false;
                        chartObj.title.exporting.useWebFonts = false;
                        var allPromises = [
                            chartObj.title.exporting.getSVG("svg", {"scale": 1}, true),
                            chartObj.exporting.getSVG("svg", {"scale": bocAmchart4.printScale}, true)
                        ];
                        if (
                            typeof chartObj.legend === "object" &&
                            chartObj.legend.parent.className === "Container" &&
                            chartObj.legend.htmlContainer.style.display !== 'none'
                        ) {
                            chartObj.legend.parent.exporting.useWebFonts = false;
                            allPromises.push(chartObj.legend.parent.exporting.getSVG("svg", {"scale": 1}, true));
                        }
                        if (typeof chartObj.notes === "object" && chartObj.notes.parent.className === "Container") {
                            chartObj.notes.parent.exporting.useWebFonts = false;
                            allPromises.push(chartObj.notes.parent.exporting.getSVG("svg", {"scale": 1}, true));
                        }
                        Promise.all(allPromises).then(function (valArray) {
                            valArray.forEach(function (info) {
                                var imageSvg = document.createElement("img");
                                imageSvg.src = info;
                                imageSvg.alt = "";
                                printDiv.appendChild(imageSvg);
                            });

                            bocAmchart4.vars[chartObj.bocSettings.id].printDone = true;
                            bocAmchart4.modifyChartToDefault(chartObj);
                        }).catch(function (error) {
                            // eslint-disable-next-line no-console
                            console.error(error);
                            bocAmchart4.modifyChartToDefault(chartObj);
                        });
                    }
                }
            }, 100);
        });
    });
};

/**
 * Back compatibility fix (jQuery events remaining from old bundle)
 * @return {void}
 */
bocAmchart4.beforePrint = function () {};

/**
 * Back compatibility fix (jQuery events remaining from old bundle)
 * @return {void}
 */
bocAmchart4.afterPrint = function () {};
